import { createSelector } from 'reselect';

export const getSelectedFilters = (state) => state.ui.filterPanel;

export const getSelectedRouteFilters = createSelector(
  getSelectedFilters,
  ({ selectedRouteFilters }) => selectedRouteFilters
);

export const getSelectedStopFilters = createSelector(
  getSelectedFilters,
  ({ selectedStopFilters }) => selectedStopFilters
);
